export default __webpack_public_path__ + "static/comparisons-model-explain-e1841c4f8dd1a0703f9cc247e4f6662e.webp";